import React from 'react';
import { Typography, Box } from '@mui/material';
import DonutChart from "./Charts";

const PortfolioComponent = ({ perfil }) => {
  const styles = {
    perfilStyle: {
        marginTop:"20px", marginBottom:"30px", color:"#2a4887", fontSize:{xs:"5vh", md:"42px"}, textAlign:"center"
    },
    boxPerfilStyle: {
        display:"flex", flexDirection:"column", alignItems:"center", marginRight:"30px", marginLeft:"30px"
    },
    boxPerfiles: {
      // Estilos para el contenedor de texto del perfil
    },
    textStyle: {
      textAlign:"center", marginBottom:"20px"
    },
    textStyle2: {
      // Otros estilos para el texto del perfil
    },
  };

const conservador1 = "Una cartera de acciones conservadora se caracteriza por su enfoque en la seguridad y la estabilidad. En este tipo de cartera, la mayoría de las inversiones se destinan a acciones de empresas bien establecidas y de bajo riesgo, así como a bonos y activos más seguros. El objetivo principal es preservar el capital y generar un flujo de ingresos estable a lo largo del tiempo. Esta cartera suele ser adecuada para inversores que buscan un enfoque de inversión a largo plazo y desean evitar una exposición significativa a la volatilidad del mercado."
//const conservador2 = "Incluye acciones de sectores estables como retail, con Coca Cola, Pepsi, Walmart y McDonald's. Empresas farmacéuticas y de cuidado personal como Johnson & Johnson y Procter & Gamble también se destacan por su resistencia en recesiones."
//const conservador3 = "Con menor peso, JPMorgan brinda exposición al crecimiento mundial, Visa destaca en pagos sin riesgo de impagos, y AT&T ofrece dividendo atractivo y baja volatilidad. Las tecnológicas Apple y Microsoft, junto con el holding Berkshire Hathaway de Warren Buffet, completan la cartera."
const moderado1 = "Una cartera de acciones moderada equilibra el riesgo y la recompensa. En esta cartera, se invierte en una combinación de acciones de empresas establecidas y bonos de calidad. El objetivo es lograr un crecimiento del capital a través de las inversiones en acciones, al tiempo que se mantiene cierto nivel de estabilidad y generación de ingresos mediante los bonos. Esta cartera es adecuada para inversores que desean un equilibrio entre el crecimiento a largo plazo y la protección contra la volatilidad del mercado."
//const moderado2 = "Con menor ponderación tenemos a HP Inc y 3M, empresas industriales con marcas y productos respetables y difíciles de reemplazar. Encontramos a Visa, principal gestora de pagos del mundo y Johnson & Johnson con productos de higiene lideres a nivel mundial."
//const moderado3 = "Tenemos a Disney, que forma parte de todas nuestras infancias, generando un activo intangible incalculable y AT&T, empresa de telecomunicaciones que aporta estabilidad a la cartera. Nos encontramos a Paypal, una de las Fintech más confiables del mundo y terminamos con Pfizer, empresa de farmacéuticos que luego de ganar mucho dinero durante el covid está pasando por un momento financiero complicado."
const arriesgado1 = "Una cartera de arriesgada se centra en la búsqueda de altos retornos a través de inversiones en acciones más volátiles y mayor riesgo. Podemos encontrar acciones de empresas emergentes, startups y sectores más volátiles del mercado. El objetivo es maximizar el potencial de crecimiento, pero a costa de una mayor exposición al riesgo. Esta cartera es adecuada para inversores que buscan un alto rendimiento y un horizonte de inversión a largo plazo para poder tolerar la volatilidad y las fluctuaciones del mercado."
//const arriesgado2 = "Destaca una mayor ponderación en el sector tecnológico, con Alphabet y Amazon como principales posiciones. Ambas empresas, creciendo muy rápido y abarcando cada vez más mercado. Alibaba y Paypal, aunque atraviesan caídas en bolsa, están muy sanas financieramente. 3M y Disney que están pasando por momentos financieros complicados, pero confiamos en que ambas van a recuperarse y dar una muy buena rentabilidad."
//const arriesgado3 = "HP Inc, representa una apuesta segura en la fabricación de computadoras. Además, tenemos cuatro posiciones pequeñas en empresas con valoraciones actuales menos atractivas, pero con un potencial significativo a futuro. Tesla, líder en autos eléctricos, Meta (Facebook, Instagram, Whatsapp), AMD (fabricante de componentes electrónicos) y MercadoLibre, se destacan por su prometedor potencial."

  // Lógica para determinar qué contenido mostrar dependiendo del perfil seleccionado
  let contenidoPerfil;
  if (perfil === "Conservador") {
    contenidoPerfil = (
      <>
        <Typography variant="h3" sx={styles.perfilStyle}>
          Perfil Conservador
        </Typography>
        <Box sx={styles.boxPerfilStyle}>
          <Box sx={styles.boxPerfiles}>
            <Typography sx={styles.textStyle}>{conservador1}</Typography>
            {/* <br />
            <Typography sx={styles.textStyle2}>{conservador2}</Typography>
            <br />
            <Typography sx={styles.textStyle2}>{conservador3}</Typography> */}
          </Box>
          <DonutChart profile={"Conservador"} />
        </Box>
      </>
    );
  } else if (perfil === "Moderado") {
    contenidoPerfil = (
      <>
        <Typography variant="h3" sx={styles.perfilStyle}>
          Perfil Moderado
        </Typography>
        <Box sx={styles.boxPerfilStyle}>
          <Box sx={styles.boxPerfiles}>
            <Typography sx={styles.textStyle}>{moderado1}</Typography>
            {/* <br />
            <Typography sx={styles.textStyle2}>{moderado2}</Typography>
            <br />
            <Typography sx={styles.textStyle2}>{moderado3}</Typography> */}
          </Box>
          <DonutChart profile={"Moderado"} />
        </Box>
      </>
    );
  } else if (perfil === "Arriesgado") {
    contenidoPerfil = (
      <>
        <Typography variant="h3" sx={styles.perfilStyle}>
          Perfil Arriesgado
        </Typography>
        <Box sx={styles.boxPerfilStyle}>
          <Box sx={styles.boxPerfiles}>
            <Typography sx={styles.textStyle}>{arriesgado1}</Typography>
            {/* <br />
            <Typography sx={styles.textStyle2}>{arriesgado2}</Typography>
            <br />
            <Typography sx={styles.textStyle2}>{arriesgado3}</Typography> */}
          </Box>
          <DonutChart profile={"Arriesgado"} />
        </Box>
      </>
    );
  } else {
    // En caso de que el perfil no esté definido o sea null
    contenidoPerfil = (
      <Typography variant="h3" sx={styles.perfilStyle}>
        Selecciona un perfil para mostrar detalles.
      </Typography>
    );
  }

  return (
    <Box>
      {contenidoPerfil}
    </Box>
  );
};

export default PortfolioComponent;